import { cityAttractionsConstants } from "../constants/CityAttractionsConstants";


var prodCpy = {};
export const cityAttractionsReducer = (state, action) => {

	switch (action.type) {

		case cityAttractionsConstants.SEARCH_SUCCESS:

			return {
				...state,
				tours: action.data,
				loading: false
			};

			case cityAttractionsConstants.SEARCH_FAILURE:

			return {
				...state,
				tours: [],
				loading: false
			};


			case cityAttractionsConstants.SEARCH_REQUEST:

			return {
				...state,
				loading: true
			};


			case cityAttractionsConstants.ARICLE_SUCCESS:

			return {
				...state,
				article: action.data,
				loading: false
			};

			case cityAttractionsConstants.ARICLE_FAILURE:

			return {
				...state,
				aricle: "",
				loading: false
			};


			case cityAttractionsConstants.ARICLE_REQUEST:

			console.log("evo mee")
			return {
				...state,
				loading: true
			};


		default:
			return state;
	}
};
